<div class="card">
  <img class="card-img-top" [src]="logoUrl" alt="Product Logo" />
  <div class="card-title">Admin Login</div>

  <div class="card-body">
    <form [formGroup]="form">
      <div class="form-group">
        <label for="email">Email</label>
        <input formControlName="email" id="email" type="email" class="form-control" placeholder="example@domain.com" />
        <div *ngIf="f['email'].touched && f['email'].invalid" class="error">
          <div *ngIf="f['email'].errors && f['email'].errors['required']" class="error">
            Email is required.
          </div>
          <div *ngIf="f['email'].errors && f['email'].errors['email']" class="error">
            Please, enter valid email address.
          </div>
        </div>
      </div>

      <br />
      <div class="form-group">
        <label for="pass">Password</label>
        <input formControlName="pass" id="pass" type="password" class="form-control"
          placeholder="Enter your Password" />
        <div *ngIf="f['pass'].touched && f['pass'].invalid" class="error">
          <div *ngIf="f['pass'].errors && f['pass'].errors['required']" class="error">
            Password is required
          </div>
          <div *ngIf="f['pass'].errors && f['pass'].errors['minlength']" class="error">
            Password should be 6 character.
          </div>
        </div>
      </div>

      <div class="form-group d-flex justify-content-between">
        <button class="btn btn-primary submit" [disabled]="form.invalid" type="submit" (click)="submit()">
          Submit
        </button>
      </div>
    </form>
  </div>
</div>